var map = {
	"./MINECON_2011_Cape_(texture).png": 69345,
	"./MINECON_2012_Cape_(texture).png": 94711,
	"./MINECON_2013_Cape_(texture).png": 96752,
	"./MINECON_2015_Cape_(texture).png": 26206,
	"./MINECON_2016_Cape_(texture).png": 43851,
	"./MINECON_2019_Cape_(texture).png": 16906,
	"./elytra.png": 45526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;